import React from "react";
import { Grid, Typography } from "e100-react-components";
import { getLocalDate } from "common/utils";
import { IconBattery, LocationStatusIcon } from "shared/components";
import { useStyles } from "./styles";
import { Chip } from "./Chip";
import { getAutoStatusByDate } from "shared/utils/getAutoStatusByDate";

interface ChipsProps {
  address: string;
  lastActivityDate: string;
  batteryCharge: number;
}

export const Chips = ({
  address,
  batteryCharge,
  lastActivityDate,
}: ChipsProps) => {
  const classes = useStyles();
  return (
    <Grid
      container
      classes={{
        root: classes.container,
      }}
    >
      <Chip label={'address'} />
      <Chip label={getLocalDate(lastActivityDate)} />
      <Chip
        label={`Activity`}
        avatar={
          <span className={classes.avatar}><LocationStatusIcon status={getAutoStatusByDate(lastActivityDate)} /></span>
        }
      />
      <Chip
        label={`Battery: ${batteryCharge} %`}
        avatar={<IconBattery batteryCharge={batteryCharge} />}
      />
      <Typography
        variant="caption"
        color="textSecondary"
        classes={{ root: classes.lastUpdateText }}
      >
        Last update: {getLocalDate(lastActivityDate)}
      </Typography>
    </Grid>
  );
};
